export default "__VITE_ASSET__576563f0__"